type Base64String = string;

/**
 * 将 Base64 编码的字符串转换为 UTF-8 字符串
 * @param {string} base64String - Base64 编码的字符串
 * @returns {string} - UTF-8 编码的字符串
 */
function base64ToUtf8(base64String: Base64String = '') {
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  const decoder = new TextDecoder('utf-8');
  const utf8String = decoder.decode(bytes);
  return utf8String;
}

/**
 * 将 UTF-8 字符串转换为 Base64 编码的字符串
 * @param {string} utf8String - UTF-8 编码的字符串
 * @returns {string} - Base64 编码的字符串
 */
function utf8ToBase64(sourceStr: string = ''): Base64String {
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(sourceStr);
  let binaryString = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binaryString += String.fromCharCode(uint8Array[i]);
  }
  const base64String = btoa(binaryString);
  return base64String;
}

function JWTDecode(code: string) {
  const token = code;
  // 分割 JWT 的三部分 head是编码格式不需要 尾部是签名也不需要
  const payloadBase64 = token.split('.')[1];
  // Base64Url 解码（兼容标准 Base64）
  function base64UrlDecode(str: string) {
    // 替换 URL 安全的 Base64 字符
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    // 补全长度（必须是4的倍数）
    switch (output.length % 4) {
      case 0: break;
      case 2: output += '=='; break;
      case 3: output += '='; break;
      default: throw new Error('非法的 Base64Url 字符串');
    }
    // 解码
    return JSON.parse(decodeURIComponent(escape(atob(output))));
  }
  const payload = base64UrlDecode(payloadBase64);
  console.log('Payload:', payload);
  return payload;
}
// 403情况也需要刷新token的接口 23小时55分一次
const url403 = [/\/merge_requests\/\d+\/discussions/, /\/issues\/\d+\/discussions/];

export { base64ToUtf8, utf8ToBase64, JWTDecode, url403 };
